import axios from "axios";
import utils from "../utils/auth.js";

let tmpConfig = null;
let apiNum = 0;
export let baseURL = "//" + location.hostname + "/manager";
if (location.hostname == "localhost") {
    // baseURL = "//ubiallinone-test.sigreal.cn/manager";
    // baseURL = "https://cvp.sigreal.cn/manager";
    // baseURL = "//cvptest.sigreal.com.cn/manager";
    // ceshi2_mousen  Kang_2504@Sigreal
    // baseURL = "https://evcard.sigreal.cn/manager";
    baseURL = "https://cpicfleet.sigreal.cn/manager";
}

export const service = axios.create({
    baseURL: baseURL,
});

// 请求拦截器
service.interceptors.request.use(
    (config) => {
        tmpConfig = null;
        tmpConfig = config;
        if (localStorage.getItem("X-From-Tenant")) {
            config.headers["X-From-Tenant"] =
                localStorage.getItem("X-From-Tenant");
        }
        config.headers["X-From-Business-Line"] = "ubi";
        localStorage.setItem("X-From-Business-Line", "ubi");

        config.headers.Authorization = "Bearer " + utils.getToken();
        var userInfo = localStorage.getItem("userInfo");
        if (userInfo) {
            userInfo = JSON.parse(userInfo);
            if (config.method.toLowerCase() == "get") {
                if (config.params) {
                    config.params.batchId = userInfo.batchId;
                    // config.params.companyId=userInfo.company;
                    config.params.userId = userInfo.id;
                }
            } else {
                if (config.data) {
                    config.data.batchId = userInfo.batchId;
                    // config.data.companyId=userInfo.company;
                    config.data.userId = userInfo.id;
                }
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    (res) => {
        if (res.data.code == 401) {
            localStorage.setItem("tokenError", 401);
            apiNum == 1 &&
                window.alert("抱歉，当前账号在其他设备登录，已强制退出");
            apiNum++;
            localStorage.clear();
            location.href = "/";
        }

        // 根据配置决定返回完整响应还是仅data
        if (res.config.fullResponse) {
            return res;
        }

        return res.data;
    },
    (error) => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    apiNum == 1 &&
                        window.alert(
                            "抱歉，当前账号在其他设备登录，已强制退出"
                        );
                    apiNum++;
                    localStorage.clear();
                    location.href = "/";
                    break;
            }
        }
    }
);

/**
 * 核心请求方法
 * @param {Object} options - 请求配置
 * @param {string} [options.method='GET'] - 请求方法
 * @param {string} options.url - 请求URL
 * @param {Object} [options.data] - 请求体数据（POST/PUT等）
 * @param {Object} [options.params] - URL参数（GET请求）
 * @param {boolean} [options.fullResponse=false] - 是否返回完整响应对象
 * @returns {Promise} - 根据fullResponse参数决定返回响应数据或完整响应
 */
export function request(options) {
    return service(options);
}

export function download(options) {
    return request({
        ...options,
        responseType: "blob",
        fullResponse: true, // 通常需要完整响应获取 headers
    });
}

export default request;
